import { memo } from 'react';

import { ALERT_VARIANTS, Alert, Typography } from '@didaskill/ui/design-system';

import * as styles from './InformationBanner.styles';

export type InformationBannerProps = {
  title: string;
  subtitle: string;
  variant?: ALERT_VARIANTS;
  onRequestClose?: () => void;
};

export const InformationBannerBase = ({
  title,
  subtitle,
  variant = ALERT_VARIANTS.INFO,
  onRequestClose,
}: InformationBannerProps) => {
  return (
    <Alert variant={variant} onRequestClose={onRequestClose}>
      <div css={styles.container}>
        <Typography variant={Typography.VARIANTS.BODY_LARGE_BOLD}>{title}</Typography>

        <Typography variant={Typography.VARIANTS.BODY_MEDIUM_REGULAR}>{subtitle}</Typography>
      </div>
    </Alert>
  );
};

InformationBannerBase.displayName = 'InformationBanner';

export const InformationBanner = memo(InformationBannerBase);
